/** Remaining UI copy: everything switches language except the site brand and strategy names. */

const BRAND = 'HMA Quant Strategies';
const titled = (page) => `${page} · ${BRAND}`;

const modelReasonsEn = {
  conservative: {
    BES: 'Trend following with low drawdown',
    ARES: 'Moderate market timing',
    JANUS: 'Market-neutral, uncorrelated',
  },
  moderate: {
    ARES: 'Efficient market timing',
    BES: 'Stability and consistency',
    DEIMOS: 'Higher risk exposure',
    JANUS: 'Market-neutral hedge',
  },
  aggressive: {
    DEIMOS: 'Maximum leveraged exposure',
    FOBOS: 'Two-layer sleeve with risk',
    ASCALAFO: 'Additional overlay',
  },
  balanced: {
    ARES: 'Core market timing',
    BES: 'Core trend following',
    JANUS: 'Market-neutral hedge',
    TYR: 'Regime rotation',
  },
  growth: {
    DEIMOS: 'Main growth engine',
    ARES: 'Robust market timing',
    BES: 'Stability in trends',
    JANUS: 'Volatility reduction',
  },
  income: {
    JANUS: 'Market-neutral, very stable',
    BES: 'Conservative trend following',
    ARES: 'Unlevered timing',
  },
};

const modelReasonsEs = {
  conservative: {
    BES: 'Seguimiento de tendencia con bajo drawdown',
    ARES: 'Timing de mercado moderado',
    JANUS: 'Neutral al mercado, descorrelacionado',
  },
  moderate: {
    ARES: 'Timing de mercado eficiente',
    BES: 'Estabilidad y consistencia',
    DEIMOS: 'Mayor exposición al riesgo',
    JANUS: 'Cobertura neutral al mercado',
  },
  aggressive: {
    DEIMOS: 'Máxima exposición apalancada',
    FOBOS: 'Doble capa con riesgo',
    ASCALAFO: 'Capa adicional',
  },
  balanced: {
    ARES: 'Timing de mercado principal',
    BES: 'Seguimiento de tendencia principal',
    JANUS: 'Cobertura neutral al mercado',
    TYR: 'Rotación por régimen',
  },
  growth: {
    DEIMOS: 'Motor principal de crecimiento',
    ARES: 'Timing de mercado robusto',
    BES: 'Estabilidad en tendencias',
    JANUS: 'Reducción de volatilidad',
  },
  income: {
    JANUS: 'Neutral al mercado, muy estable',
    BES: 'Seguimiento de tendencia conservador',
    ARES: 'Timing sin apalancamiento',
  },
};

const modelReasonsDe = {
  conservative: {
    BES: 'Trendfolge mit geringem Drawdown',
    ARES: 'Moderates Market-Timing',
    JANUS: 'Marktneutral, unkorreliert',
  },
  moderate: {
    ARES: 'Effizientes Market-Timing',
    BES: 'Stabilität und Konsistenz',
    DEIMOS: 'Höheres Risiko',
    JANUS: 'Marktneutrales Hedge',
  },
  aggressive: {
    DEIMOS: 'Maximale gehebelte Exposition',
    FOBOS: 'Zwei Schichten mit Risiko',
    ASCALAFO: 'Zusätzliche Overlay-Schicht',
  },
  balanced: {
    ARES: 'Kern-Market-Timing',
    BES: 'Kern-Trendfolge',
    JANUS: 'Marktneutrales Hedge',
    TYR: 'Regime-Rotation',
  },
  growth: {
    DEIMOS: 'Hauptwachstumsmotor',
    ARES: 'Robustes Market-Timing',
    BES: 'Stabilität in Trends',
    JANUS: 'Volatilitätsreduktion',
  },
  income: {
    JANUS: 'Marktneutral, sehr stabil',
    BES: 'Konservative Trendfolge',
    ARES: 'Timing ohne Hebel',
  },
};

const modelReasonsIt = {
  conservative: {
    BES: 'Trend following con drawdown contenuto',
    ARES: 'Market timing moderato',
    JANUS: 'Market neutral, decorrelato',
  },
  moderate: {
    ARES: 'Market timing efficiente',
    BES: 'Stabilità e coerenza',
    DEIMOS: 'Maggiore esposizione al rischio',
    JANUS: 'Hedge market neutral',
  },
  aggressive: {
    DEIMOS: 'Massima esposizione con leva',
    FOBOS: 'Doppia fascia con rischio',
    ASCALAFO: 'Overlay aggiuntivo',
  },
  balanced: {
    ARES: 'Market timing di base',
    BES: 'Trend following di base',
    JANUS: 'Hedge market neutral',
    TYR: 'Rotazione di regime',
  },
  growth: {
    DEIMOS: 'Motore principale di crescita',
    ARES: 'Market timing robusto',
    BES: 'Stabilità nei trend',
    JANUS: 'Riduzione della volatilità',
  },
  income: {
    JANUS: 'Market neutral, molto stabile',
    BES: 'Trend following conservativo',
    ARES: 'Timing senza leva',
  },
};

const modelReasonsPl = {
  conservative: {
    BES: 'Podążanie za trendem z niskim drawdownem',
    ARES: 'Umiarkowany market timing',
    JANUS: 'Market neutral, nieskorelowany',
  },
  moderate: {
    ARES: 'Skuteczny market timing',
    BES: 'Stabilność i regularność',
    DEIMOS: 'Większa ekspozycja na ryzyko',
    JANUS: 'Hedging market-neutral',
  },
  aggressive: {
    DEIMOS: 'Maksymalna ekspozycja z dźwignią',
    FOBOS: 'Dwie warstwy z ryzykiem',
    ASCALAFO: 'Dodatkowa nakładka',
  },
  balanced: {
    ARES: 'Główny market timing',
    BES: 'Główne podążanie za trendem',
    JANUS: 'Hedging market-neutral',
    TYR: 'Rotacja reżimów',
  },
  growth: {
    DEIMOS: 'Główny motor wzrostu',
    ARES: 'Solidny market timing',
    BES: 'Stabilność w trendach',
    JANUS: 'Redukcja zmienności',
  },
  income: {
    JANUS: 'Market-neutral, bardzo stabilny',
    BES: 'Konserwatywne podążanie za trendem',
    ARES: 'Timing bez dźwigni',
  },
};

const modelReasonsZh = {
  conservative: {
    BES: '低回撤趋势跟踪',
    ARES: '温和择时',
    JANUS: '市场中性、低相关',
  },
  moderate: {
    ARES: '高效择时',
    BES: '稳定与一致性',
    DEIMOS: '更高风险敞口',
    JANUS: '市场中性对冲',
  },
  aggressive: {
    DEIMOS: '最大杠杆敞口',
    FOBOS: '带风险的双层结构',
    ASCALAFO: '额外叠加',
  },
  balanced: {
    ARES: '核心择时',
    BES: '核心趋势跟踪',
    JANUS: '市场中性对冲',
    TYR: '体制轮动',
  },
  growth: {
    DEIMOS: '主要增长引擎',
    ARES: '稳健择时',
    BES: '趋势中的稳定',
    JANUS: '降低波动',
  },
  income: {
    JANUS: '市场中性、非常稳定',
    BES: '保守趋势跟踪',
    ARES: '无杠杆择时',
  },
};

const reasons = (map) => {
  const out = {};
  for (const [id, reasonsMap] of Object.entries(map)) {
    out[id] = { reasons: reasonsMap };
  }
  return out;
};

export const restEn = {
  nav: {
    toggleMenu: 'Toggle menu',
    closeMenu: 'Close menu',
    performance: 'Performance',
  },
  pageTitle: {
    home: BRAND,
    strategies: titled('Strategies'),
    strategy: `{name} · ${BRAND}`,
    performance: titled('Performance'),
    reports: titled('Reports'),
    research: titled('Research'),
    portfolio: titled('Portfolio'),
    about: titled('About'),
    contact: titled('Contact'),
    institutional: titled('Mandates'),
    login: titled('Log in'),
    account: titled('Account'),
    privacy: titled('Privacy Policy'),
    terms: titled('Terms of Service'),
    legal: titled('Legal Notice'),
    quantLab: titled('Quant Lab'),
    terminal: titled('Terminal'),
    auth: titled('Signing in'),
    reset: titled('Reset password'),
  },
  meta: {
    description: 'Systematic strategies, an interactive Quant Lab, and weekly research reports. Educational quantitative research.',
  },
  charts: {
    year: 'Year',
    gold: 'Gold',
    goldMix: '50/50 S&P + Gold',
  },
  metrics: {
    avgWeeks: 'Avg weeks',
    drawdown: 'Drawdown',
    tabs: { drawdown: 'Drawdown' },
  },
  reportCard: {
    stop: 'Stop',
    target: 'Target',
    winRate: 'Win rate',
  },
  calculator: {
    evolution: 'Portfolio evolution',
    portfolioValue: 'Portfolio value',
    contributed: 'Contributed',
  },
  auth: {
    verifying: 'Verifying your authentication…',
    failed: 'Authentication failed',
    redirectingLogin: 'Redirecting to login…',
    noSession: 'No session found',
  },
  marketHours: {
    title: 'Market status',
    open: 'Open',
    closed: 'Closed',
    loading: 'Loading',
    weekend: 'Weekend',
    holidayClosed: 'Closed — {name}',
    closesIn: 'Closes in {hours}h {mins}m',
    opensIn: 'Opens in {hours}h {mins}m',
    opensInHours: 'Opens in {hours}h',
  },
  holidays: {
    newYear: "New Year's Day",
    mlk: 'MLK Day',
    presidents: "Presidents' Day",
    goodFriday: 'Good Friday',
    memorial: 'Memorial Day',
    independence: 'Independence Day',
    labor: 'Labor Day',
    thanksgiving: 'Thanksgiving',
    christmas: 'Christmas',
    newYearEve: "New Year's Eve",
    easterMonday: 'Easter Monday',
    earlyMay: 'Early May Bank Holiday',
    springBank: 'Spring Bank Holiday',
    summerBank: 'Summer Bank Holiday',
    boxing: 'Boxing Day',
    bank: 'Bank Holiday',
    foundation: 'National Foundation Day',
    labour: 'Labour Day',
    christmasEve: 'Christmas Eve',
    generic: 'Holiday',
  },
  home: {
    hero: {
      livePlatforms: 'Wikifolio, Darwinex, eToro →',
    },
  },
  strategies: {
    annualReturns: 'Annual returns',
  },
  performancePage: {
    drawdown: 'Drawdown',
    series: 'Series',
    title: 'Performance',
  },
  weeklyReports: {
    popular: 'Popular',
  },
  about: {
    expertiseTitle: 'Expertise',
    trackRecordTitle: 'Track record',
  },
  portfolioPage: {
    maxDrawdown: 'Max drawdown',
    equityCurve: 'Equity curve',
  },
  common: {
    error: 'Error',
  },
  models: reasons(modelReasonsEn),
  terminal: {
    operational: 'Operational',
    exit: 'Exit',
    versionBar: 'TERMINAL v1.0 · HMA QUANT STRATEGIES',
    regime: {
      bull: 'Bull',
      neutral: 'Neutral',
      bear: 'Bear',
      bullMarket: 'Bull market',
      neutralMarket: 'Neutral market',
      bearMarket: 'Bear market',
      persistence: 'Persistence',
      volatility: 'Volatility',
    },
  },
};

export const restEs = {
  nav: {
    toggleMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    performance: 'Rendimiento',
  },
  pageTitle: {
    home: BRAND,
    strategies: titled('Estrategias'),
    strategy: `{name} · ${BRAND}`,
    performance: titled('Rendimiento'),
    reports: titled('Informes'),
    research: titled('Investigación'),
    portfolio: titled('Cartera'),
    about: titled('Sobre mí'),
    contact: titled('Contacto'),
    institutional: titled('Mandatos'),
    login: titled('Entrar'),
    account: titled('Cuenta'),
    privacy: titled('Política de privacidad'),
    terms: titled('Términos de servicio'),
    legal: titled('Aviso legal'),
    quantLab: titled('Lab cuantitativo'),
    terminal: titled('Terminal'),
    auth: titled('Iniciando sesión'),
    reset: titled('Nueva contraseña'),
  },
  meta: {
    description: 'Estrategias sistemáticas, un Lab cuantitativo interactivo e informes semanales. Investigación cuantitativa educativa.',
  },
  charts: {
    year: 'Año',
    gold: 'Oro',
    goldMix: '50/50 S&P + Oro',
  },
  metrics: {
    avgWeeks: 'Semanas medias',
    drawdown: 'Caída máxima',
    tabs: { drawdown: 'Caída máxima' },
  },
  reportCard: {
    stop: 'Stop',
    target: 'Objetivo',
    winRate: 'Acierto',
  },
  calculator: {
    evolution: 'Evolución de la cartera',
    portfolioValue: 'Valor de la cartera',
    contributed: 'Aportado',
  },
  auth: {
    verifying: 'Verificando tu autenticación…',
    failed: 'La autenticación ha fallado',
    redirectingLogin: 'Redirigiendo al inicio de sesión…',
    noSession: 'No se encontró ninguna sesión',
  },
  marketHours: {
    title: 'Estado de los mercados',
    open: 'Abierto',
    closed: 'Cerrado',
    loading: 'Cargando',
    weekend: 'Fin de semana',
    holidayClosed: 'Cerrado — {name}',
    closesIn: 'Cierra en {hours}h {mins}m',
    opensIn: 'Abre en {hours}h {mins}m',
    opensInHours: 'Abre en {hours}h',
  },
  holidays: {
    newYear: 'Año Nuevo',
    mlk: 'Día de Martin Luther King',
    presidents: 'Día de los Presidentes',
    goodFriday: 'Viernes Santo',
    memorial: 'Día de los Caídos',
    independence: 'Día de la Independencia',
    labor: 'Día del Trabajo',
    thanksgiving: 'Acción de Gracias',
    christmas: 'Navidad',
    newYearEve: 'Nochevieja',
    easterMonday: 'Lunes de Pascua',
    earlyMay: 'Festivo de inicios de mayo',
    springBank: 'Festivo de primavera',
    summerBank: 'Festivo de verano',
    boxing: 'Boxing Day',
    bank: 'Festivo bancario',
    foundation: 'Día de la Fundación Nacional',
    labour: 'Día del Trabajo',
    christmasEve: 'Nochebuena',
    generic: 'Festivo',
  },
  home: {
    hero: {
      livePlatforms: 'Wikifolio, Darwinex, eToro →',
    },
  },
  strategies: {
    annualReturns: 'Rentabilidades anuales',
  },
  performancePage: {
    drawdown: 'Caída máxima',
    series: 'Serie',
    title: 'Rendimiento',
  },
  weeklyReports: {
    popular: 'Destacado',
  },
  about: {
    expertiseTitle: 'Especialización',
    trackRecordTitle: 'Historial',
  },
  portfolioPage: {
    maxDrawdown: 'Caída máxima',
    equityCurve: 'Curva de capital',
  },
  common: {
    error: 'Error',
  },
  models: reasons(modelReasonsEs),
  terminal: {
    operational: 'Operativo',
    exit: 'Salir',
    versionBar: 'TERMINAL v1.0 · HMA QUANT STRATEGIES',
    regime: {
      bull: 'Alcista',
      neutral: 'Neutral',
      bear: 'Bajista',
      bullMarket: 'Mercado alcista',
      neutralMarket: 'Mercado neutral',
      bearMarket: 'Mercado bajista',
      persistence: 'Persistencia',
      volatility: 'Volatilidad',
    },
  },
};

export const restDe = {
  nav: {
    toggleMenu: 'Menü öffnen',
    closeMenu: 'Menü schließen',
    performance: 'Wertentwicklung',
    portfolio: 'Portfolio-Builder',
  },
  pageTitle: {
    home: BRAND,
    strategies: titled('Strategien'),
    strategy: `{name} · ${BRAND}`,
    performance: titled('Wertentwicklung'),
    reports: titled('Berichte'),
    research: titled('Analysen'),
    portfolio: titled('Portfolio-Builder'),
    about: titled('Über mich'),
    contact: titled('Kontakt'),
    institutional: titled('Mandate'),
    login: titled('Anmelden'),
    account: titled('Konto'),
    privacy: titled('Datenschutz'),
    terms: titled('Nutzungsbedingungen'),
    legal: titled('Impressum'),
    quantLab: titled('Quant-Labor'),
    terminal: titled('Terminal'),
    auth: titled('Anmeldung'),
    reset: titled('Passwort zurücksetzen'),
  },
  meta: {
    description: 'Systematische Strategien, ein interaktives Quant-Labor und wöchentliche Research-Berichte. Quantitative Bildungsforschung.',
  },
  charts: {
    year: 'Jahr',
    gold: 'Gold',
    goldMix: '50/50 S&P + Gold',
  },
  metrics: {
    avgWeeks: 'Ø Wochen',
    drawdown: 'Drawdown',
    tabs: { drawdown: 'Drawdown' },
  },
  reportCard: {
    stop: 'Stopp',
    target: 'Ziel',
    winRate: 'Trefferquote',
  },
  calculator: {
    evolution: 'Portfolioentwicklung',
    portfolioValue: 'Portfoliowert',
    contributed: 'Eingezahlt',
  },
  auth: {
    verifying: 'Authentifizierung wird geprüft…',
    failed: 'Authentifizierung fehlgeschlagen',
    redirectingLogin: 'Weiterleitung zur Anmeldung…',
    noSession: 'Keine Sitzung gefunden',
  },
  marketHours: {
    title: 'Marktstatus',
    open: 'Offen',
    closed: 'Geschlossen',
    loading: 'Laden',
    weekend: 'Wochenende',
    holidayClosed: 'Geschlossen — {name}',
    closesIn: 'Schließt in {hours}h {mins}m',
    opensIn: 'Öffnet in {hours}h {mins}m',
    opensInHours: 'Öffnet in {hours}h',
  },
  holidays: {
    newYear: 'Neujahr',
    mlk: 'Martin-Luther-King-Tag',
    presidents: 'Presidents’ Day',
    goodFriday: 'Karfreitag',
    memorial: 'Memorial Day',
    independence: 'Unabhängigkeitstag',
    labor: 'Labor Day',
    thanksgiving: 'Thanksgiving',
    christmas: 'Weihnachten',
    newYearEve: 'Silvester',
    easterMonday: 'Ostermontag',
    earlyMay: 'Early May Bank Holiday',
    springBank: 'Spring Bank Holiday',
    summerBank: 'Summer Bank Holiday',
    boxing: 'Boxing Day',
    bank: 'Bankfeiertag',
    foundation: 'Gründungstag',
    labour: 'Tag der Arbeit',
    christmasEve: 'Heiligabend',
    generic: 'Feiertag',
  },
  home: {
    hero: {
      livePlatforms: 'Wikifolio, Darwinex, eToro →',
    },
  },
  strategies: {
    annualReturns: 'Jahresrenditen',
  },
  performancePage: {
    drawdown: 'Drawdown',
    series: 'Serie',
    title: 'Wertentwicklung',
  },
  weeklyReports: {
    popular: 'Beliebt',
  },
  about: {
    expertiseTitle: 'Fachkompetenz',
    trackRecordTitle: 'Erfolgsbilanz',
  },
  portfolioPage: {
    maxDrawdown: 'Max. Drawdown',
    equityCurve: 'Kapitalkurve',
  },
  common: {
    error: 'Fehler',
  },
  models: reasons(modelReasonsDe),
  terminal: {
    operational: 'Betriebsbereit',
    exit: 'Beenden',
    versionBar: 'TERMINAL v1.0 · HMA QUANT STRATEGIES',
    regime: {
      bull: 'Hausse',
      neutral: 'Neutral',
      bear: 'Baisse',
      bullMarket: 'Bull-Markt',
      neutralMarket: 'Neutraler Markt',
      bearMarket: 'Bärenmarkt',
      persistence: 'Persistenz',
      volatility: 'Volatilität',
    },
  },
};

export const restIt = {
  nav: {
    toggleMenu: 'Apri menu',
    closeMenu: 'Chiudi menu',
    performance: 'Rendimento',
  },
  pageTitle: {
    home: BRAND,
    strategies: titled('Strategie'),
    strategy: `{name} · ${BRAND}`,
    performance: titled('Rendimento'),
    reports: titled('Report'),
    research: titled('Ricerca'),
    portfolio: titled('Portafoglio'),
    about: titled('Chi sono'),
    contact: titled('Contatto'),
    institutional: titled('Mandati'),
    login: titled('Accedi'),
    account: titled('Account'),
    privacy: titled('Privacy'),
    terms: titled('Termini di servizio'),
    legal: titled('Note legali'),
    quantLab: titled('Lab quantitativo'),
    terminal: titled('Terminale'),
    auth: titled('Accesso'),
    reset: titled('Nuova password'),
  },
  meta: {
    description: 'Strategie sistematiche, un Lab quantitativo interattivo e report settimanali. Ricerca quantitativa educativa.',
  },
  charts: {
    year: 'Anno',
    gold: 'Oro',
    goldMix: '50/50 S&P + Oro',
  },
  metrics: {
    avgWeeks: 'Settimane medie',
    drawdown: 'Drawdown',
    tabs: { drawdown: 'Drawdown' },
  },
  reportCard: {
    stop: 'Stop',
    target: 'Target',
    winRate: 'Win rate',
  },
  calculator: {
    title: 'CALCOLATORE DI RENDIMENTI',
    subtitle: 'Calcola quanto avresti guadagnato investendo in',
    historicalData: 'con dati storici reali',
    initialInvestment: 'Investimento iniziale',
    monthlyContribution: 'Contributo mensile (opzionale)',
    calculate: 'Calcola i rendimenti',
    evolution: 'Evoluzione del portafoglio',
    portfolioValue: 'Valore del portafoglio',
    contributed: 'Versato',
    results: {
      finalValue: 'VALORE FINALE',
      totalGain: 'GUADAGNO TOTALE',
      returnPercent: 'RENDIMENTO %',
      summary: 'Riepilogo:',
      summaryText1: 'Con un investimento iniziale di',
      summaryText2: 'e versamenti mensili di',
      summaryText3: ', avresti investito in totale',
      summaryText4: 'in',
      summaryText5: ', ottenendo un valore finale di',
      years: 'anni',
    },
  },
  auth: {
    verifying: 'Verifica dell’autenticazione…',
    failed: 'Autenticazione non riuscita',
    redirectingLogin: 'Reindirizzamento al login…',
    noSession: 'Nessuna sessione trovata',
  },
  marketHours: {
    title: 'Stato dei mercati',
    open: 'Aperto',
    closed: 'Chiuso',
    loading: 'Caricamento',
    weekend: 'Fine settimana',
    holidayClosed: 'Chiuso — {name}',
    closesIn: 'Chiude tra {hours}h {mins}m',
    opensIn: 'Apre tra {hours}h {mins}m',
    opensInHours: 'Apre tra {hours}h',
  },
  holidays: {
    newYear: 'Capodanno',
    mlk: 'Martin Luther King Day',
    presidents: 'Presidents’ Day',
    goodFriday: 'Venerdì Santo',
    memorial: 'Memorial Day',
    independence: 'Independence Day',
    labor: 'Labor Day',
    thanksgiving: 'Thanksgiving',
    christmas: 'Natale',
    newYearEve: 'San Silvestro',
    easterMonday: 'Lunedì di Pasqua',
    earlyMay: 'Early May Bank Holiday',
    springBank: 'Spring Bank Holiday',
    summerBank: 'Summer Bank Holiday',
    boxing: 'Boxing Day',
    bank: 'Festività bancaria',
    foundation: 'Festa nazionale',
    labour: 'Festa del lavoro',
    christmasEve: 'Vigilia di Natale',
    generic: 'Festività',
  },
  home: {
    hero: {
      livePlatforms: 'Wikifolio, Darwinex, eToro →',
    },
  },
  strategies: {
    annualReturns: 'Rendimenti annuali',
  },
  performancePage: {
    drawdown: 'Drawdown',
    series: 'Serie',
    title: 'Rendimento',
  },
  weeklyReports: {
    popular: 'In evidenza',
  },
  about: {
    expertiseTitle: 'Competenze',
    trackRecordTitle: 'Track record',
  },
  portfolioPage: {
    maxDrawdown: 'Max drawdown',
    equityCurve: 'Curva di capitale',
  },
  common: {
    error: 'Errore',
  },
  models: reasons(modelReasonsIt),
  terminal: {
    operational: 'Operativo',
    exit: 'Esci',
    versionBar: 'TERMINAL v1.0 · HMA QUANT STRATEGIES',
    regime: {
      bull: 'Rialzista',
      neutral: 'Neutrale',
      bear: 'Ribassista',
      bullMarket: 'Mercato rialzista',
      neutralMarket: 'Mercato neutrale',
      bearMarket: 'Mercato ribassista',
      persistence: 'Persistenza',
      volatility: 'Volatilità',
    },
  },
};

export const restPl = {
  nav: {
    toggleMenu: 'Otwórz menu',
    closeMenu: 'Zamknij menu',
    performance: 'Wyniki',
  },
  pageTitle: {
    home: BRAND,
    strategies: titled('Strategie'),
    strategy: `{name} · ${BRAND}`,
    performance: titled('Wyniki'),
    reports: titled('Raporty'),
    research: titled('Badania'),
    portfolio: titled('Portfel'),
    about: titled('O mnie'),
    contact: titled('Kontakt'),
    institutional: titled('Mandaty'),
    login: titled('Logowanie'),
    account: titled('Konto'),
    privacy: titled('Prywatność'),
    terms: titled('Regulamin'),
    legal: titled('Nota prawna'),
    quantLab: titled('Laboratorium'),
    terminal: titled('Terminal'),
    auth: titled('Logowanie'),
    reset: titled('Reset hasła'),
  },
  meta: {
    description: 'Strategie systematyczne, interaktywne laboratorium ilościowe i cotygodniowe raporty. Edukacyjne badania ilościowe.',
  },
  charts: {
    year: 'Rok',
    gold: 'Złoto',
    goldMix: '50/50 S&P + złoto',
  },
  metrics: {
    avgWeeks: 'Śr. tygodnie',
    drawdown: 'Drawdown',
    tabs: { drawdown: 'Drawdown' },
  },
  reportCard: {
    stop: 'Stop',
    target: 'Cel',
    winRate: 'Skuteczność',
  },
  calculator: {
    evolution: 'Ewolucja portfela',
    portfolioValue: 'Wartość portfela',
    contributed: 'Wpłacono',
  },
  auth: {
    verifying: 'Weryfikacja uwierzytelnienia…',
    failed: 'Uwierzytelnienie nie powiodło się',
    redirectingLogin: 'Przekierowanie do logowania…',
    noSession: 'Nie znaleziono sesji',
  },
  marketHours: {
    title: 'Status rynków',
    open: 'Otwarty',
    closed: 'Zamknięty',
    loading: 'Ładowanie',
    weekend: 'Weekend',
    holidayClosed: 'Zamknięty — {name}',
    closesIn: 'Zamyka się za {hours}h {mins}m',
    opensIn: 'Otwiera się za {hours}h {mins}m',
    opensInHours: 'Otwiera się za {hours}h',
  },
  holidays: {
    newYear: 'Nowy Rok',
    mlk: 'Dzień Martina Luthera Kinga',
    presidents: 'Dzień Prezydentów',
    goodFriday: 'Wielki Piątek',
    memorial: 'Memorial Day',
    independence: 'Święto Niepodległości',
    labor: 'Labor Day',
    thanksgiving: 'Święto Dziękczynienia',
    christmas: 'Boże Narodzenie',
    newYearEve: 'Sylwester',
    easterMonday: 'Poniedziałek Wielkanocny',
    earlyMay: 'Early May Bank Holiday',
    springBank: 'Spring Bank Holiday',
    summerBank: 'Summer Bank Holiday',
    boxing: 'Boxing Day',
    bank: 'Dzień wolny od banku',
    foundation: 'Święto Narodowe',
    labour: 'Święto Pracy',
    christmasEve: 'Wigilia',
    generic: 'Święto',
  },
  home: {
    hero: {
      livePlatforms: 'Wikifolio, Darwinex, eToro →',
    },
  },
  strategies: {
    annualReturns: 'Stopy roczne',
  },
  performancePage: {
    drawdown: 'Drawdown',
    series: 'Seria',
    title: 'Wyniki',
  },
  weeklyReports: {
    popular: 'Wyróżnione',
  },
  about: {
    expertiseTitle: 'Kompetencje',
    trackRecordTitle: 'Dorobek',
  },
  portfolioPage: {
    maxDrawdown: 'Maks. drawdown',
    equityCurve: 'Krzywa kapitału',
  },
  common: {
    error: 'Błąd',
  },
  models: reasons(modelReasonsPl),
  terminal: {
    operational: 'Działa',
    exit: 'Wyjdź',
    versionBar: 'TERMINAL v1.0 · HMA QUANT STRATEGIES',
    regime: {
      bull: 'Hossa',
      neutral: 'Neutralny',
      bear: 'Bessa',
      bullMarket: 'Rynek byka',
      neutralMarket: 'Rynek neutralny',
      bearMarket: 'Rynek niedźwiedzia',
      persistence: 'Trwałość',
      volatility: 'Zmienność',
    },
  },
};

export const restZh = {
  nav: {
    toggleMenu: '打开菜单',
    closeMenu: '关闭菜单',
    performance: '业绩',
  },
  pageTitle: {
    home: BRAND,
    strategies: titled('策略'),
    strategy: `{name} · ${BRAND}`,
    performance: titled('业绩'),
    reports: titled('报告'),
    research: titled('研究'),
    portfolio: titled('组合'),
    about: titled('关于'),
    contact: titled('联系'),
    institutional: titled('机构委托'),
    login: titled('登录'),
    account: titled('账户'),
    privacy: titled('隐私政策'),
    terms: titled('服务条款'),
    legal: titled('法律声明'),
    quantLab: titled('量化实验室'),
    terminal: titled('终端'),
    auth: titled('登录中'),
    reset: titled('重置密码'),
  },
  meta: {
    description: '系统化策略、交互式量化实验室与每周研究报告。量化教育研究。',
  },
  charts: {
    year: '年份',
    gold: '黄金',
    goldMix: '50/50 标普 + 黄金',
  },
  metrics: {
    avgWeeks: '平均周数',
    drawdown: '回撤',
    tabs: { drawdown: '回撤' },
  },
  reportCard: {
    stop: '止损',
    target: '目标',
    winRate: '胜率',
  },
  calculator: {
    title: '收益计算器',
    subtitle: '计算如果投资于',
    historicalData: '的真实历史收益',
    initialInvestment: '初始投资',
    monthlyContribution: '每月追加（可选）',
    calculate: '计算收益',
    evolution: '组合演变',
    portfolioValue: '组合价值',
    contributed: '已投入',
    results: {
      finalValue: '最终价值',
      totalGain: '总收益',
      returnPercent: '收益率 %',
      summary: '摘要：',
      summaryText1: '以初始投资',
      summaryText2: '和每月追加',
      summaryText3: '，你总共投入了',
      summaryText4: '，历时',
      summaryText5: '，最终价值为',
      years: '年',
    },
  },
  auth: {
    verifying: '正在验证登录…',
    failed: '验证失败',
    redirectingLogin: '正在跳转到登录页…',
    noSession: '未找到会话',
  },
  marketHours: {
    title: '市场状态',
    open: '开市',
    closed: '收市',
    loading: '加载中',
    weekend: '周末',
    holidayClosed: '休市 — {name}',
    closesIn: '{hours}小时{mins}分钟后收市',
    opensIn: '{hours}小时{mins}分钟后开市',
    opensInHours: '{hours}小时后开市',
  },
  holidays: {
    newYear: '元旦',
    mlk: '马丁·路德·金纪念日',
    presidents: '总统日',
    goodFriday: '耶稣受难日',
    memorial: '阵亡将士纪念日',
    independence: '独立日',
    labor: '劳动节',
    thanksgiving: '感恩节',
    christmas: '圣诞节',
    newYearEve: '除夕',
    easterMonday: '复活节星期一',
    earlyMay: '五月初银行假日',
    springBank: '春季银行假日',
    summerBank: '夏季银行假日',
    boxing: '节礼日',
    bank: '银行假日',
    foundation: '建国纪念日',
    labour: '劳动节',
    christmasEve: '平安夜',
    generic: '假日',
  },
  home: {
    hero: {
      livePlatforms: 'Wikifolio, Darwinex, eToro →',
    },
  },
  strategies: {
    annualReturns: '年度收益',
  },
  performancePage: {
    drawdown: '回撤',
    series: '序列',
    title: '业绩',
  },
  weeklyReports: {
    popular: '热门',
  },
  about: {
    expertiseTitle: '专长',
    trackRecordTitle: '业绩记录',
  },
  portfolioPage: {
    maxDrawdown: '最大回撤',
    equityCurve: '权益曲线',
  },
  common: {
    error: '错误',
  },
  models: reasons(modelReasonsZh),
  terminal: {
    operational: '运行中',
    exit: '退出',
    versionBar: 'TERMINAL v1.0 · HMA QUANT STRATEGIES',
    regime: {
      bull: '牛市',
      neutral: '中性',
      bear: '熊市',
      bullMarket: '牛市',
      neutralMarket: '中性市场',
      bearMarket: '熊市',
      persistence: '持续性',
      volatility: '波动率',
    },
  },
};
